import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';
import { RouterLinkDirective } from '@hyundai/ng-common-lib';

@Component({
    selector: 'app-promotion-link',
    standalone: true,
    templateUrl: './promotion-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLinkDirective],
})
export class PromotionLinkComponent {
    link = input.required<string>();
    fragment = input<string>();
    target = input<'_self' | '_blank'>('_self');

    click = output();
}
